import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import eagle from '../../../../assets/images/partnership/icons/eagle.svg';
import './Support.css';

const Support = () => {
  return (
    <section className="support">
      <div className="support__inner">
        <div className="support__panel">
          <Reveal className="support__content">
            <img
              className="support__eagle"
              src={eagle}
              alt=""
              aria-hidden="true"
            />
            <h2 className="support__title">
              Professionalism, Clarity, and Support.
            </h2>
            <p className="support__text">
              We prioritize long-term relationships with partners who value
              service quality, clear communication, and structured
              collaboration. Our team supports onboarding and operational
              alignment to maintain a consistent partner experience.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Support;
